const UrlApi = {
  // baseUrl: "https://api-dev.safrati.ai/admin",
  // baseUrlImage: "https://api-dev.safrati.ai/admin",
  // baseUrlclient: "https://api-dev.safrati.ai/user",
  // baseUrlImageClient: "https://api-dev.safrati.ai/user",
  baseUrl: process.env.REACT_APP_BASEURL,
  baseUrlImage: process.env.REACT_APP_BASEURLIMAGE,
  baseUrlclient: process.env.REACT_APP_BASEURL_CLIENT,
  baseUrlImageClient: process.env.REACT_APP_BASEURLIMAGE,
  auth: {
    login: "auth/login",
    autologin: "auth/autologin",
    signup: "auth/signup",
    logout: "auth/logout",
    forgotPassword: "auth/forgot-password",
    resetPassword: "auth/reset-password",
  },
  country: {
    get: "country/get",
    add: "country/add",
    edit: "country/edit",
    delete: "country/delete",
    search: "country/search",
  },
  groups: {
    get: "group/get",
    add: "group/add",
    edit: "group/edit",
    delete: "group/delete",
  },
  questions_category: {
    get: "questions_category/get",
    add: "questions_category/add",
    edit: "questions_category/edit",
    delete: "questions_category/delete",
  },
  questionnaires: {
    get: "questionnaires/get",
    getAllOptionsList: "questionnaires/get-all-options-list",
    add: "questionnaires/add",
    edit: "questionnaires/edit",
    delete: "questionnaires/delete",
    search: "questionnaires/search",
    get_by_country_and_group: "questionnaires/get_by_country_and_group",
    manage_by_country_and_group: "questionnaires/manage_by_country_and_group",
    add_by_country_and_group: "questionnaires/add_by_country_and_group",
    update_by_country_and_group: "questionnaires/update_by_country_and_group",
  },

  documents: {
    get: "documents/get",
    getVisaTypeDocuments: "documents/get-visa-type-documents",
    add: "documents/add",
    edit: "documents/edit",
    delete: "documents/delete",
  },
  nationality: {
    get: "nationality/get",
    add: "nationality/add",
    edit: "nationality/edit",
    delete: "nationality/delete",
    search: "nationality/search",
  },
  visaType: {
    get: "visaType/get",
    add: "visaType/add",
    edit: "visaType/edit",
    delete: "visaType/delete",
  },
  admins: {
    get: "admins/get",
    add: "admins/add",
    edit: "admins/edit",
    delete: "admins/delete",
    getUserType: "admins/get_user_type",
    getUserPrivilegs: "admins/privileg",
    addUserPrivilegs: "admins/addprivileg",
    editUserPrivilegs: "admins/editprivileg",
    deleteprivileg: "admins/deleteprivileg",
  },
  users: {
    get: "users/get",
    add: "users/add",
    edit: "users/edit",
    delete: "users/delete",
    get_countries: "users/get_countries",
  },
  admin_logs: {
    get: "admin_logs/get",
    edit: "admin_logs/edit",
  },
  settings: {
    get: "settings/get",
    edit: "settings/update_settings",
  },
  reOrder: "re-order",
  countryVisaType: "country_management_details/countryVisaType/",
  visaTypeNationality: {
    get: "country_management_details/natonality/get/",
    add: "country_management_details/natonality/add",
    edit: "country_management_details/natonality/update",
    delete: "country_management_details/natonality/delete",
  },
  copy: {
    create: "copy/create",
  },
  countries_gallery: {
    get: "country/gallery/get/",
    add: "country/gallery/add",
    edit: "country/gallery/edit",
    delete: "country/gallery/delete",
  },
  prices: {
    get: "price/get",
    add: "price/add",
    edit: "price/edit",
    delete: "price/delete",
  },
  trusted_by: {
    get: "about_us/trusted_by",
    add: "about_us/add_trusted_by",
    edit: "about_us/update_trusted_by",
    delete: "about_us/delete_trusted_by",
  },
  testimonials: {
    get: "home/testimonials",
    add: "home/add_testimonials",
    edit: "home/update_testimonials",
    delete: "home/delete_testimonials",
  },
  working_process: {
    get: "home/working_process",
    add: "home/create_working_process",
    edit: "home/update_working_process",
    delete: "home/delete_working_process",
    get_by_visa_type: "home/get-by-visa-type",
    update_by_visa_type: "home/update-by-visa-type",
    add_by_visa_type: "home/add-by-visa-type",
    delete_by_visa_type: "home/delete-by-visa-type",
  },
  stats: {
    get: "home/stats",
    add: "home/add_stats",
    edit: "home/update_stats",
    delete: "home/delete_stats",
  },
  clients: {
    get: "clients/get",
    add: "clients/add",
    edit: "clients/edit",
    delete: "clients/delete",
    search: "clients/search",
  },
  services: {
    get: "about_us/services",
    add: "about_us/service",
    edit: "about_us/update_service",
    delete: "about_us/delete_services",
  },
  contact_us: {
    get: "contact_us/get",
    add: "contact_us/add_contact",
    edit: "contact_us/update_contact",
    delete: "contact_us/delete_contact",
  },
  faq: {
    get: "faq/get",
    add: "faq/add",
    edit: "faq/edit",
    delete: "faq/delete",
    get_by_visa_type: "faq/get-by-visa-type",
    update_by_visa_type: "faq/update-by-visa-type",
    add_by_visa_type: "faq/add-by-visa-type",
    delete_by_visa_type: "faq/delete-by-visa-type",
  },
  visa_type_documents: {
    add: "/visaTypeDocuments/add",
    edit: "/visaTypeDocuments/edit",
  },
  request_reviews: {
    get_by_country: "request_reviews/get-by-country",
    edit: "request_reviews/edit",
    delete: "request_reviews/delete",
  },
  requests: {
    get: "request/get",
    search: "request/search",
    get_one: "request/get-one",
    update_request: "request/update-request",
  },
  chat: {
    get_chat: "chat/get_chat",
    get_chat_messages: "chat/get_messages",
    upload: "request/upload-doc/chat",
  },
  stats: {
    get: "stats/get",
    get_table: "home/stats",
    add: "home/add_stats",
    edit: "home/update_stats",
    delete: "home/delete_stats",
  },
  awards: {
    get: "awards/get",
    add: "awards/add",
    update: "awards/update",
    delete: "awards/delete",
  },
  ai_chat: {
    sessions: "ai/sessions",
    messages: "ai/messages",
  },
};

export default UrlApi;
